import { If } from '../../Atoms/Conditionals';
import { ALIGN, SocialMedia, SOCIAL_MEDIA } from '../SocialMedia';

interface IAUTHOR_CARD_PROPS extends SOCIAL_MEDIA {
  name: string;
  designation: string;
  authorImg: string;
  description: string;
  slug: string;
}

export const AuthorSideBio = ({
  name,
  designation,
  authorImg,
  description,
  linkedin,
  facebook,
  twitter,
}: IAUTHOR_CARD_PROPS): JSX.Element => {
  return (
    <div className="p-6 rounded-xl mb-6 sm:px-0 py-4 sm:mb-2">
      <div className="pb-6 flex justify-between items-center sm:pb-4">
        <div className="flex gap-4 flex-col items-center sm:flex-row">
          <If condition={!!authorImg}>
            <div className="author-cirle bg-none w-24 h-24">
              <img src={authorImg} alt="author-img" width={96} height={96} />
            </div>
          </If>
          <div>
            <h1 className="text-base font-bold text-font-500 capitalize sm:text-s-24">
              {name}
            </h1>
            <div className="text-s-12 mt-2 text-font-200 font-semibold sm:text-s-14">
              {designation}
            </div>
          </div>
        </div>
      </div>
      <p className="text-base">{description} </p>

      <SocialMedia
        linkedin={linkedin}
        facebook={facebook}
        twitter={twitter}
        align={ALIGN.left}
      />
    </div>
  );
};
